/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRectangleRoundedTop = createReactComponent("outline", "rectangle-rounded-top", "IconRectangleRoundedTop", [["path", { "d": "M9 6h6a6 6 0 0 1 6 6v5a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-5a6 6 0 0 1 6 -6z", "key": "svg-0" }]]);

export { IconRectangleRoundedTop as default };
//# sourceMappingURL=IconRectangleRoundedTop.mjs.map
